import React, {useMemo, useState, useEffect} from 'react';
import classNames from 'classnames';
import {useToggle} from 'react-use';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import styles from './card-circle.module.css';
import CSVLink from "../../../useHook/useCSV";

function CardCircle(props) {
    const {data, title, description, downloadCSV} = props;

    const [list, setList] = useState({
        '3div': [],
        '5div': [],
    });

    const [on, toggle] = useToggle(false);

    useEffect(() => {
        const left = data['3div'] || [];
        const right = data['5div'] || [];

        for (let i = 0; i < 3; i++) {
            const currentDataLeft = left[i];
            left[i] = currentDataLeft ? {
                ...left[i],
                opacity: parseInt(left[i].color)/100,
                ratio: left[i].ratio,
            } : {
                color: '20%',
                opacity: 0.2,
                ratio: 0,
            };
        }

        for (let i = 0; i < 5; i++) {
            const currentDataRight = right[i];
            right[i] = currentDataRight ? {
                ...right[i],
                opacity: parseInt(right[i].color)/100,
                ratio: right[i].ratio,
            } : {
                color: '20%',
                opacity: 0.2,
                ratio: 0,
            };
        }
        setList({ '3div': left, '5div': right });
    }, [data]);

    const memoList = useMemo(() => {
        return on ? list['5div'] : list['3div'];
    }, [list, on]);

    const dataCSV = useMemo(() => {
        if(list['3div'].length === 0 || list['5div'].length === 0) return [];

        if(on) {
            return [
                [title],
                ['左割合', '左中割合', '中割合', '右中割合', '右割合'],
                [
                    list['5div'][0].ratio + '%',
                    list['5div'][1].ratio + '%',
                    list['5div'][2].ratio + '%',
                    list['5div'][3].ratio + '%',
                    list['5div'][4].ratio + '%',
                ],
                [description || '']
            ];
        }

        return [
            [title],
            ['左割合', '中割合', '右割合'],
            [
                list['3div'][0].ratio + '%',
                list['3div'][1].ratio + '%',
                list['3div'][2].ratio + '%',
            ],
            [description || '']
        ];
    }, [list, on, title, description]);

    return <div className={styles.container}>
        <div className={styles.circleWrapper}>
            <img className={styles.image} src="/img/graph/pic_ground.svg" alt="" />
            {memoList.map((item, index) => {
                return <div key={index} style={{opacity: item.opacity}}
                    className={classNames(styles.card, on ? styles[`card${index + 1}`] : styles[`card-left-${index + 1}`], !on && styles.cardLeft)}>
                    <span className={styles.cardInfo}>
                        {item.ratio}%
                    </span>
                </div>
            })}
        </div>
        <div className={styles.buttonWrapper}>
            <button onClick={toggle} className={classNames(styles.button, !on && styles.buttonActive)}>3分割</button>
            <button onClick={toggle} className={classNames(styles.button, on && styles.buttonActive)}>5分割</button>
        </div>
        <CSVLink data={dataCSV} autoDownload={downloadCSV} filename={'player-topic-card-circle.csv'} />
    </div>
}

CardCircle.propTypes = {
    data: PropTypes.object
};

CardCircle.defaultProps = {
    data: {
        '3div': [],
        '5div': [],
    }
};

export default CardCircle;
